
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"88","height":"86","viewBox":"0 0 109 107"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#71d3b9","d":"M54.319 11.74l33.836 16.348 8.357 36.735-23.415 29.46H35.54l-23.416-29.46 8.357-36.735z"}}),_c('path',{attrs:{"fill":"#0a294a","d":"M37.105 23.507l31-.155 19.45 24.22-6.748 30.357-27.863 13.635-27.998-13.356-7.049-30.287z"}}),_c('g',[_c('image',{attrs:{"width":"37","height":"35","transform":"translate(38 37)","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAjCAYAAAATx8MeAAADIElEQVRYhbXYP4xVRRTHcd7+gWVXgQgJrhISCjUGCWqhiY0bEzTRgkILC2sLqYyFrYl/YomJFoTCYGtMSLSzMfFPQ4QYE7MKFvgH2OASYf88YVk/FjPPzN6de+fe5e1pNntmzu9879w5Z+a+LXhuyyYavsDfWEAfN7GC/U1BXwn2E17A3UOCGcOP1tt17CgFH84E/oo37hBqNqN7uwiUCDTZNTzcAWYKNzI6FzHe5ak+LoDdxoGWWu9l4i93AopCDxagYFWLpcebmdjPOwFFoV58TSVbxraC1rFcYAeWZ9J/TrWAgkvoNYi+UhN3pAXQ27iQOna2hIK5BuGjNTGzBaDBovxRHTjTAeybGvGZhphPMFaZ3xMa7MDmq4I9nO4A9kMG6vFCzE18kMw/VxlfrlvKtzqAnUzipuV7VJ0tZ3zzWaiY4PkO4sdjzPkOMXW2tRYqJjmIf1qKHYsx328QZgl7G4ESsO0dhJ/EiLBvutquVkAJ2Fb83FJ8JsZcTnx/CSdCzlbwUCegCtwvLcGmMBETzorNVqjuEYziHryEBzYMlIB91BLsAHZp6P5DMUzGvy+3gFpVqqQ7hOnhU/yLV6Pv2RZgfWzfDKBRoVxTOxXHtgl3rSabw8gwge4XLv05+zLO2Y3FAtj5iubZjQI9XUhEaKzjcX5TN+/HOROJ7yJGuwC93wJoYNewQ9h3n2XGf8c47rP2dLgiFk4JZgTfdQCChYrGO8nYUoSdFIrkf3/b1ZnEbzHoKl7Ha5hvAFqROR7wIv4Uvv2mrT12rmhTkUKFDarodGa8nwEqPq3Q2dPjZVHbZopHksDdmfGnKkC3sKegeW+cN7A5YaPvEYqiuU3gwxi4mpuMJxLx5dLTxhVK+9difBupf07Tl1FF4Ghm/FKyQsU7Dw4lelcxEf37rN3w8+o+Uq2/ws4Im3QnTkRfX+XSXwB7NOqOV/zT1l8cv8Vj0rMyJl9Qb7ewry1Qopt9zcIpsFLJcV21knGXtRtzYBcM6eehSr4jSY4ldTcK7Bf21yrexfSwYZJcY3ERbqxboczkqc0CyeT6WiyC1P4D4/T+Q68OoiYAAAAASUVORK5CYII="}})])])
          )
        }
      }
    